import View, { recipients } from './View';

export { View, recipients };
